import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";

import App from "./App.js";
import "./css/main.scss";

ReactDOM.render(<App />, document.getElementById("root"));
